export const initialState = {
  contributors: [],
  contributorStatistics: []
};
